import { JSX } from 'react';
import { ListItem } from '@bg-components/Modals/TopSettingsModal/List/ListItem';
import { GameLimitsModal } from '@bg-components/Modals/GameLimitsModal';
import { useModalsManager, t, ModalName, ISkywardGameId } from '@bg-shared';

interface IProps {
    gameId?: ISkywardGameId;
}

export const GameLimits = (props: IProps): JSX.Element => {
    const modalManager = useModalsManager();

    return (
        <ListItem
            label={t.string('game_limits')}
            onClick={() => {
                modalManager.open(ModalName.GAME_LIMITS, GameLimitsModal, { gameId: props.gameId });
            }}
        />
    );
};
